import React from 'react';
import { COLORS } from '../../utils/constants';
import { Link, useLocation } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';
import { 
  Home, 
  TrendingUp, 
  Wallet, 
  User,
  Rocket
} from 'lucide-react';

const MobileBottomNav = ({ hidden }) => {
  const location = useLocation();
  const { t } = useLanguage();

  const navItems = [
    { path: '/', icon: Home, label: t('home') },
    { path: '/ido', icon: Rocket, label: 'IDO' },
    { path: '/trading', icon: TrendingUp, label: t('trading'), primary: true },
    { path: '/wallet', icon: Wallet, label: t('wallet') },
    { path: '/profile', icon: User, label: t('profile') },
  ];

  const isActive = (path) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname === path || location.pathname.startsWith(path + '/');
  };

  // Hide on trading page - it has its own navigation
  if (hidden || location.pathname === '/trading') {
    return null;
  }

  return (
    <nav
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: COLORS.card,
        borderTop: `1px solid ${COLORS.border}`,
        display: 'flex',
        justifyContent: 'space-around',
        alignItems: 'center',
        paddingBottom: 'max(8px, env(safe-area-inset-bottom, 0px))',
        zIndex: 9999,
        height: '72px',
      }}
    >
      {navItems.map((item) => {
        const Icon = item.icon;
        const active = isActive(item.path);
        const isPrimary = item.primary;

        if (isPrimary) {
          return (
            <Link
              key={item.path}
              to={item.path}
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                textDecoration: 'none',
                marginTop: '-20px',
              }}
            >
              <div
                style={{
                  width: '56px',
                  height: '56px',
                  borderRadius: '50%',
                  backgroundColor: COLORS.primary,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  boxShadow: '0 4px 12px rgba(240, 185, 11, 0.4)',
                }}
              >
                <Icon size={26} color="#000" strokeWidth={2.5} />
              </div>
              <span
                style={{
                  fontSize: '10px',
                  marginTop: '4px',
                  color: COLORS.primary,
                  fontWeight: '600',
                }}
              >
                {item.label}
              </span>
            </Link>
          );
        }

        return (
          <Link
            key={item.path}
            to={item.path}
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              textDecoration: 'none',
              padding: '8px 12px',
              minWidth: '60px',
            }}
          >
            <Icon
              size={22}
              color={active ? COLORS.primary : COLORS.textSecondary}
              strokeWidth={active ? 2.5 : 2}
            />
            <span
              style={{
                fontSize: '10px',
                marginTop: '4px',
                color: active ? COLORS.primary : COLORS.textSecondary,
                fontWeight: active ? '600' : '400',
              }}
            >
              {item.label}
            </span>
          </Link>
        );
      })}
    </nav>
  );
};

export default MobileBottomNav;
